<template>
    <v-container fluid>
        <v-card height="725">
            <v-card-title class="justify-center">Layout items</v-card-title>
            <v-divider/>
            <v-card-text class="pt-3 pb-6">
                <v-text-field v-model="search" clearable @click:clear="clearSearch" @keyup="searchDetails" label="Search" hideDetails dense/>
            </v-card-text>
            <v-divider/>
            <v-card-text id="tree" class="detail-list" v-if="search===''||search===null">
                <v-treeview ref="x" :items="items" item-key="id" :open.sync="openNodes" dense>   
                    <template v-slot:label="{ item }">
                        <draggable 
                            :disabled="item.disabled" 
                            class="draggable-list" 
                            :list="[item]" 
                            :group="{name: 'layout', pull: 'clone', put: false}" 
                            :sort="false"
                            :clone="cloneItem"
                            @end="dragEnd"
                            >
                            <v-card flat class="mx-0 pa-0 px-2" @click="cloneItem(item)" :color="selected_item === item.id ? 'primary' : 'white'">
                                <span :class="selected_item === item.id ? 'white--text' : 'blue--text'">{{ item.name }}</span>
                            </v-card>
                        </draggable>
                    </template>
                </v-treeview>
            </v-card-text>
            <v-card-text id="tree" class="detail-list" v-else>
                <v-row>
                    <v-col cols="12" v-for="item in fiteredItems" :key="item.id">
                        <draggable 
                            :disabled="item.disabled" 
                            class="draggable-list" 
                            :list="[item]" 
                            :group="{name: 'layout', pull: 'clone', put: false}" 
                            :sort="false"
                            :clone="cloneItem"
                            @end="dragEnd"
                            >
                            <v-card flat class="mx-0 pa-0 px-2" @click="cloneItem(item)" :color="selected_item === item.id ? 'primary' : 'white'">
                                <span :class="selected_item === item.id ? 'white--text' : 'blue--text'">{{ item.name }}</span>
                            </v-card>
                        </draggable>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
    import draggable from "vuedraggable";
    export default {
        components: {
            draggable,
        },
        props: {
        },
        data() {
            return {
                selected_item: "",
                target: "",
                search: "",
                fiteredItems: "",
                items: [],
                openNodes: [],
                scrollOptions: {
                    container: "#tree",
                    duration: 300,
                    offset: 0,
                    easing: "easeInOutCubic",
                },
            }
        },
        mounted() {
            this.getHsiiItems();
        },
        methods: {
            clearSearch() {
                this.search = "";
                this.searchDetails();
            },
            searchDetails() {
                let fiteredItems = [];
                for (let iIndex=0;iIndex<this.items.length;iIndex++) {
                    for (let jIndex=0;jIndex<this.items[iIndex].children.length;jIndex++) {
                        if (this.items[iIndex].children[jIndex].name.toLowerCase().includes(this.search.toLowerCase())) {
                            fiteredItems.push(this.items[iIndex].children[jIndex]);
                        }
                    }
                }
                this.fiteredItems = fiteredItems;
            },
            getHsiiItems() {
                this.$axios.post("ares/json/ares/huis/hsii/getHsiiItems.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getHsiiItems"
                    },
                    getHsiiItems: {
                    }
                }).then(res => {
                    if (res.data.error) {
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.error.message,
                            color: "error"
                        }); 
                    } else {     
                        this.items = res.data.getHsiiItems;
                        this.clearSearch();
                    }
                });
            },
            cloneItem(data) {
                if (data.disabled) {
                    this.selected_item = "";
                    if (this.openNodes.length === 0) {
                        this.openNodes = [data.id];
                        return;
                    }
                    let newNodes = [];
                    let nodeFound = false;
                    for(let iIndex=0;iIndex<this.openNodes.length;iIndex++) {
                        if (this.openNodes[iIndex] === data.id) {
                            nodeFound = true;
                        } else {
                            newNodes.push(this.openNodes[iIndex]);
                        }
                    }
                    if (!nodeFound) {
                        newNodes.push(data.id);
                    }
                    this.openNodes = newNodes;
                } else {
                    this.selected_item = data.id;
                    this.$emit("newItem", data);       
                }
            },
            dragEnd() {
                this.$emit("dragEnd");       
            },
        }  
    };
</script> 

<style scoped>
    .grab {
        cursor: pointer
    }

    .v-card {
        display: flex !important;
        flex-direction: column;
    }

    .detail-list {
        flex-grow: 1;
        overflow-y: auto;
    }
</style>